import useMe from 'hooks/API/useMe';
import { createContext, useContext, useEffect, useState } from 'react';
import users_permissions from 'utilities/user.controls';
import { AuthContext } from './AuthContext';
import PageLoader from 'components/Loaders/PageLoader';

const UserContext = createContext();
const { Provider } = UserContext;

function UserProvider({ children }) {
  const authContext = useContext(AuthContext);
  const { authState = {} } = authContext ?? {};
  const [userPermissions, setUserPermissions] = useState(null);

  const { isLoading, data } = useMe(!!authState.token);

  useEffect(() => {
    const permissions = users_permissions[`${data?.data?.key}`.toLowerCase()];
    if (permissions) setUserPermissions(permissions);

    return () => {};
  }, [data?.data]);

  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <Provider
      value={{
        userInfo: data,
        userPermissions,
      }}
    >
      {children}
    </Provider>
  );
}

export { UserProvider, UserContext };
